import React from 'react';

/**
 * 번역 문자열의 $param 위치에 React 컴포넌트를 삽입합니다.
 *
 * @example
 * // brsc.pwa_install_guide_tap_btn = "Tap the $param button"
 * insertComponent(brsc.pwa_install_guide_tap_btn, <DotsButton />)
 * // → <>Tap the <DotsButton /> button</>
 */
export function insertComponent(str: string, component: React.ReactNode): React.ReactNode {
  const parts = str.split('$param');
  if (parts.length === 1) return <>{str}</>;
  return (
    <>
      {parts[0]}
      {component}
      {parts[1]}
    </>
  );
}
